// extracted by mini-css-extract-plugin
export default {"nav-item-wrap":"NavItem_nav-item-wrap__EB+Mi","nav-icon":"NavItem_nav-icon__TFe-k","nav-active":"NavItem_nav-active__4GON2","nav-label":"NavItem_nav-label__Btzn1"};